var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell-group',{attrs:{"inset":""}},[_c('van-field',{attrs:{"rows":"1","autosize":"","label":"留言","type":"textarea","placeholder":"请输入留言"},domProps:{"innerHTML":_vm._s(_vm.license)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c9e9b5","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/user/UserLicense.vue
// module id = 521
// module chunks = 1